import React, { useEffect, useState, useContext } from "react";
import "./Weblink.css";
import URLstateContext from "../../../provider/CommonContext";
import animation from "../../../images/jm-animation.gif";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Weblink() {
  const [SubCategoryName, setSubCategoryName] = useState(
    "Scheme Expense Ratio"
  );
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  const [DataMisc, setDataMisc] = useState("");
  const [Datafact, setDatafact] = useState("");
  const [loadingshow, setLoadingshow] = useState(false);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Weblink",
      "jmf_sid-disclosures_weblink"
    );
    // trackPageView(
    //   "http://localhost:710/SIDdisclosures/Weblink",
    //   "jmf_sid-disclosures_weblink"
    // );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosures WebLink Page Loaded",
      label: "jmf_sid-disclosures_weblink",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    setLoadingshow(true);
    GetPostMethodData(BaseURL + "Getmiscellaneous", {
      IVSubCategoryName: "Scheme Expense Ratio",
    })
      .then((data) => {
        setLoadingshow(false);

        // console.log(data,"datadata");
        if (data.data != null && data.data.length > 0) {
          setDataMisc(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        setLoadingshow(false);
        //  console.log(error);
      });
  }, [BaseURL]);

  useEffect(() => {
    setLoadingshow(true);
    GetPostMethodData(BaseURL + "Getfactsheet")
      .then((data) => {
        setLoadingshow(false);

        if (data.data != null && data.data.length > 0) {
          setDatafact(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        setLoadingshow(false);
        //  console.log(error);
      });
  }, [BaseURL]);

  return (
    <>
      {loadingshow ? (
        <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
          <img src={animation} alt="" aria-hidden="true" />
          <div className="model_popup">Please Wait...</div>
        </div>
      ) : (
        <>
          <div className="schm expense product_fund-summary-sc">
            <div className="schm-pnl">
              <div className="schmeexis">
                {Datafact.length === 0 ? (
                  <p
                    style={{ textAlign: "center" }}
                    className="errormsgComNew"
                    role="alert"
                  >
                    No Data Found !!!
                  </p>
                ) : (
                  Datafact.map(({ FileName, SubCategoryName }) => (
                    <p key={FileName}>
                      Please{" "}
                      <a href={FileName} target="_blank" rel="noreferrer" className="visit-btn">
                        Click Here
                      </a>{" "}
                      to view the Factsheet
                    </p>
                  ))
                )}
              </div>
            </div>
          </div>
          <div className="schm expense product_fund-summary-sc">
            <div className="schm-pnl">
              <div className="schmeexis">
                {DataMisc.length === 0 ? (
                  <p
                    style={{ textAlign: "center" }}
                    className="errormsgComNew"
                  >
                    No Data Found !!!
                  </p>
                ) : (
               
                    <p>
                      Please{" "}
                      <a href="/Scheme-Expense-Ratio" rel="noreferrer" className="visit-btn">
                        Click Here
                      </a>{" "}
                      to download the Scheme Expense Ratio file{" "}
                    </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Weblink;
